export default __webpack_public_path__ + "static/media/banner216.a9907f57.webp";